/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateAssessmentDto { 
    termId?: number;
    /**
     * Assessment name
     */
    name?: string;
    /**
     * Maximum score for this assessment
     */
    maxScore?: number;
    /**
     * Weighting of this assessment (0 to 1)
     */
    weight?: number;
    /**
     * Type of assessment
     */
    type?: UpdateAssessmentDto.TypeEnum;
    /**
     * Whether this is a formal assessment
     */
    isFormal?: boolean;
}
export namespace UpdateAssessmentDto {
    export const TypeEnum = {
        Exam: 'EXAM',
        Test: 'TEST',
        Practical: 'PRACTICAL',
        Coursework: 'COURSEWORK'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


